import React, { useEffect } from "react"

import CurrentBookingProvider from "~components/providers/current-booking-provider"
import BookingContent from "~components/pages/booking/booking-content"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import usePersistedWidgetCheckoutParamsString from "~utils/use-persisted-widget-checkout-params-string"

export default function CheckoutFlowConfirmationStep() {
    const { checkoutQueryParams, isWidget, listing } = useCheckoutFlow()
    const { clearCheckoutParamsString } =
        usePersistedWidgetCheckoutParamsString(listing?.id)

    // On mount, clear the persisted checkout session.
    useEffect(() => {
        clearCheckoutParamsString()
    }, [])

    // For typescript. The booking id should always be here by this step.
    if (!checkoutQueryParams.booking_id) return null

    return (
        <CurrentBookingProvider bookingId={checkoutQueryParams.booking_id}>
            <BookingContent isWidget={isWidget} />
        </CurrentBookingProvider>
    )
}
